import {addEvent} from '../add-event'

export function resetFilterEvent(): boolean {
    return addEvent('reportsPageResetFilter', {})
}
